import React from 'react';

import styles from './LoginSwitcher.scss';
import ParagraphSubheaderWithIcon from 'Components/ParagraphSubheaderWithIcon';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class LoginSwitcher extends React.Component {
  render() {
    const { handleTabClick, activeTab } = this.props;

    return (
      <div className="LoginSwitcher">
        <div className="LoginSwitcher__container">
          <div
            className={`LoginSwitcher__tab${
              activeTab === 'students' ? ' is-active' : ''
            }`}
            onClick={e => handleTabClick('students')}
          >
            <ParagraphSubheaderWithIcon
              text={
                <ConnectedFormattedMessage id="login_switcher.student_label" />
              }
              type="student"
            />
          </div>
          <div
            className={`LoginSwitcher__tab${
              activeTab === 'teachers' ? ' is-active' : ''
            }`}
            onClick={e => handleTabClick('teachers')}
          >
            <ParagraphSubheaderWithIcon
              text={
                <ConnectedFormattedMessage id="login_switcher.teacher_label" />
              }
              type="teacher"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default LoginSwitcher;
